export default __webpack_public_path__ + "static/media/foto_oben_desktop.ce2b32ac.jpg";